
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dog-breed-quiz",
      function () {
        return require("private-next-pages/dog-breed-quiz.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dog-breed-quiz"])
      });
    }
  